class RUM {
  constructor() {
    if (typeof RUM.instance === 'object') {
      throw new Error('This class is a singleton!');
    }

    RUM.instance = this;

    this.dd_rum = window.DD_RUM;
  }

  static getInstance() {
    if (typeof RUM.instance !== 'object') {
      RUM.instance = new RUM();
    }

    if (!RUM.instance.dd_rum) {
      return null;
    }

    return RUM.instance;
  }

  async exec(cb) {
    return new Promise(resolve => {
      this.dd_rum.onReady(() => {
        resolve(cb());
      });
    });
  }

  setUser(user) {
    return this.exec(() => this.dd_rum.setUser(user));
  }

  setGlobalContext(context) {
    return this.exec(() => this.dd_rum.setGlobalContext(context));
  }

  sendError(error) {
    return this.exec(() => this.dd_rum.addError(error, error.context));
  }
}

export default RUM;
